<template>
	<div :class="classList" v-html="innerText" :contenteditable="canEdit" @input="changeText" @keydown="$emit('keydown', $event)" @keyup="$emit('keyup', $event)" @paste="$emit('paste', $event)"></div>
</template>

<script>
export default {
	name: 'divTextarea',
	props: {
		value: {
			type: String,
			default: ''
		},
		canEdit: {
			type: Boolean,
			default: true
		},
		classList: {
			type: String,
			default: ''
		}
	},
	data(){
		return {
			innerText: this.value
		}
	},
	watch: {
		'value'(){
			if (this.$el.innerHTML != this.value) {
				if (this.innerText == this.value) {
					this.$el.innerHTML = this.value;
				} else {
					this.innerText = this.value;
				}
			}
		}
	},
	methods: {
		changeText(){
			this.$emit('input', this.$el.innerHTML);
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/divTextarea.vue